module.exports = __webpack_public_path__ + "img/w3_subset_white.e91a643b.png";